var render, staticRenderFns
import script from "./GTimelineItemText.vue?vue&type=script&lang=ts&"
export * from "./GTimelineItemText.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a4cd352",
  null
  
)

export default component.exports